<template>
	<div class="sdk_initaial">
		<document-title-bar :pathData="isPathData"></document-title-bar>
		<h1 class="doc_main_h1">通过人员组ID获得人员组路径信息</h1>
		<h3 class="doc_main_h3">功能描述</h3>
		<p class="doc_main_p">
			将人员组ID转换成该人员组在人员管理列表内的路径信息。
		</p>
		<h3 class="doc_main_h3">函数</h3>
		<pre class="doc_main_pre"><code class="doc_main_code">const char*   __stdcall SKFaceGroupID2GroupPath(const char* pszGroupID);</code></pre>
        <h3 class="doc_main_h3">参数</h3>
        <p class="doc_main_p">pszGroupID：人员的组ID</p>
        <h3 class="doc_main_h3">返回值</h3>
        <p class="doc_main_p">
        	const char*类型，人员所在组的路径字符串。
		</p>
		<h3 class="doc_main_h3">示例代码</h3>
		<pre class="doc_main_pre"><code class="doc_main_code">const char *pszGroupPath = SKFaceGroupID2GroupPath("1111");</code></pre>
	</div>
</template>
<script>
	import DocumentTitleBar from '../../../../components/documentTitleBar';
	export default{
		components:{
			'document-title-bar':DocumentTitleBar,
		},
		data(){
			return{
				isPathData:['人脸识别','SKFaceLive-Windows','FRM接口','通过人员组ID获得人员组路径信息'],
			}
		},
		watch:{

		},
		methods:{

		},
		mounted(){

		}
	}
</script>
<style lang="less" rel="stylesheet/less">
	@import '../../../../less/index.less';
	.sdk_initaial{
	}
</style>	



// WEBPACK FOOTER //
// src/views/documents/skfacelivewindows/frm/getPath.vue